import { create } from "zustand";

type PlanTableState = {
    hoveredIndex: number;
};

type PlanTableActions = {
    actions: {
        handleHoveredIndex: (index: number) => void;
    };
};
export const usePlanTableStore = create<PlanTableState & PlanTableActions>()((set) => ({
    hoveredIndex: 0,
    actions: {
        handleHoveredIndex: (hoveredIndex: number) => {
            set({ hoveredIndex });
        },
    },
}));

export const useDriverStatusHoveredIndex = () => usePlanTableStore((state) => state.hoveredIndex);
export const useDriverStatusHoverStatus = (day: number) => usePlanTableStore((state) => state.hoveredIndex === day);
export const useDriverStatusActions = () => usePlanTableStore((state) => state.actions);
